import React, { Fragment, useMemo } from 'react';

import cx from 'classnames';

import { TRANSFER_TYPE } from 'components/Pages/Admin/GuestPortal/Flights/constants';
import itemStyles from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable/index.module.css';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import i18n from 'i18n';
import { checkIsWebview } from 'utils/mobileApplication';

import { FlightTop, FlightBottom } from './Flight';
import s from './index.module.css';
import { NoData } from './NoData';
import { TransferTop, TransferBottom } from './Transfer';

export function DetailsAndNotes(props) {
  const { item, itemIndex, onChange, isReadonly, onBlur, isPDF, dateFormat } = props;
  const isNoData = !item?.type;
  const isTransfer = item?.type === TRANSFER_TYPE;
  const [inputValue, setInputValue] = React.useState(item);

  const getValues = (inputName, inputValue) => {
    setInputValue((prev) => ({ ...prev, [inputName]: inputValue }));
    return { itemIndex, newData: { [inputName]: inputValue } };
  };

  const handleNotesChange = (inputName, inputValue) => {
    onChange(getValues(inputName, inputValue));
  };

  const handleNotesBlur = (inputName, inputValue) => {
    onBlur(getValues(inputName, inputValue));
  };

  const placeholder = useMemo(() => {
    if (isReadonly) {
      if (isPDF) return '—';

      return ' ';
    }

    if (checkIsWebview()) return ' ';

    return i18n.t('proposal_content.guest_portal.flight_and_transfers_page.add_notes');
  }, [isReadonly, isPDF, i18n.version]);

  React.useEffect(() => {
    setInputValue({ departureNotes: item.departureNotes || '', arrivalNotes: item.arrivalNotes || '' });
  }, [item]);

  if (isNoData) return <NoData {...props} />;

  return (
    <>
      <div className={cx(itemStyles.container, 'custom-flights-details-and-notes')}>
        <div className={itemStyles.block}>
          {isTransfer ? <TransferTop {...item} /> : <FlightTop {...item} isReadonly={isReadonly} isPDF={isPDF} />}

          <div className={cx(itemStyles.blockItem, itemStyles.notes, isPDF && itemStyles.notesPDF)}>
            <div className={s.redactorWrapper}>
              <Wysiwyg
                type="tertiary"
                containerClassName={s.wysiwygContainer}
                data={inputValue.departureNotes?.data?.text ? inputValue.departureNotes.data : ''}
                placeholder={placeholder}
                onChange={(value) => handleNotesChange('departureNotes', value)}
                isFormRedactor
                isTableRedactor
                hideLimit
                onBlur={() => handleNotesBlur('departureNotes', inputValue.departureNotes)}
                isReadOnly={isReadonly}
              />
            </div>
          </div>
        </div>

        <div className={itemStyles.block}>
          {isTransfer ? (
            <TransferBottom {...item} dateFormat={dateFormat} />
          ) : (
            <FlightBottom {...item} isReadonly={isReadonly} isPDF={isPDF} dateFormat={dateFormat} />
          )}

          <div className={cx(itemStyles.blockItem, itemStyles.notes, isPDF && itemStyles.notesPDF)}>
            <Wysiwyg
              type="tertiary"
              containerClassName={s.wysiwygContainer}
              data={inputValue.arrivalNotes?.data?.text ? inputValue.arrivalNotes.data : ''}
              placeholder={placeholder}
              onChange={(value) => handleNotesChange('arrivalNotes', value)}
              onBlur={() => handleNotesBlur('arrivalNotes', inputValue.arrivalNotes)}
              isReadOnly={isReadonly}
              hideLimit
            />
          </div>
        </div>
      </div>
    </>
  );
}
